@if ((isSiteSelected$ | async); as isSiteSelected) {
  <div class="container">
    <div class="toggle-bar" (click)="togglePanel()"
       [ngClass]="{
        'toggle-bar-collapsed': rightSideMode==='collapsed',
        'toggle-bar-accent': rightSideMode==='expanded',
        }">
      @if (rightSideMode==='collapsed') {
        <mat-icon>keyboard_double_arrow_right</mat-icon>
      }
      @if (rightSideMode==='expanded') {
        <mat-icon>keyboard_double_arrow_left</mat-icon>
      }
    </div>
    <items-list [hidden]="rightSideMode !== 'expanded'"></items-list>
  </div>
}
